import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { EMPTY_OBJECT } from '../../../constants/common'
import { SIZE } from '../../../constants/size'
import Modal, {
  Box as ModalBox,
  Content as ModalContent,
  Header,
} from '../../Modal'
import Text from '../../Text'
import { ConfirmationModalButtons } from '../ConfirmationModalButtons'
import { ConfirmationModalNotifications } from '../ConfirmationModalNotifications'

import { QA_NAME_CONFIRMATION_CLEAR_MODAL } from './ConfirmationModal.constants'

import * as styles from './ConfirmationModal.module.css'

function ConfirmationModal({
  ActionButtons = ConfirmationModalButtons,
  Box = ModalBox,
  Content = ModalContent,
  Description = Text,
  Notifications = ConfirmationModalNotifications,
  actionButtonsProps,
  boxSize = SIZE.MEDIUM,
  children,
  className,
  contentProps: {
    className: contentClassName = styles.content,
    ...contentProps
  } = EMPTY_OBJECT,
  description,
  descriptionProps: {
    className: descriptionClassName = styles.description,
    ...descriptionProps
  } = EMPTY_OBJECT,
  headerProps,
  loading,
  notifications,
  notificationsProps: {
    className: notificationsClassName = styles.notifications,
    ...notificationsProps
  } = EMPTY_OBJECT,
  qaName = QA_NAME_CONFIRMATION_CLEAR_MODAL,
  title,
  onCancel,
  onClose,
  onSubmit,
}) {
  const { t } = useTranslation()

  const [isLoading, setLoading] = useState(false)

  const handleSubmit = useCallback(
    async event => {
      setLoading(true)

      try {
        await onSubmit(event)
      } finally {
        setLoading(false)
      }
    },
    [onSubmit]
  )

  return (
    <Modal className={className} qaName={qaName} onClose={onClose || onCancel}>
      <Box size={boxSize}>
        <Header
          {...headerProps}
          text={title || t('Common.AttentionModalTitleKey')}
          onClose={onClose || onCancel}
        />

        <Content {...contentProps} className={contentClassName}>
          {notifications?.length > 0 ? (
            <Notifications
              {...notificationsProps}
              className={notificationsClassName}
              notifications={notifications}
            />
          ) : null}
          {Description ? (
            <Description {...descriptionProps} className={descriptionClassName}>
              {description}
            </Description>
          ) : null}
          {children}
        </Content>

        {ActionButtons ? (
          <ActionButtons
            {...actionButtonsProps}
            isLoading={loading ?? isLoading}
            onCancel={onCancel}
            onSubmit={handleSubmit}
          />
        ) : null}
      </Box>
    </Modal>
  )
}

export default ConfirmationModal
